import React from 'react'
import Select, {components as reactSelectComponents} from 'react-select'
import styles from './ReactSelect2Wrapper.scss'
import i18n from 'lib/i18n'

const _ = i18n('selectWrapper')

let selectInFocusWithin = false

/**
 * Customization object for the react-select using the same style like other components on tha site.
 */
export const customCreatableSelectStyles = {
    control: (base, state) => {
        selectInFocusWithin = state.isFocused
        return {
        ...base,
        flex: "4",
        fontSize: "12px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        color: "#000",
        backgroundColor: state.isDisabled ? "#F6F6F6" : "#FFFFFF",
        borderColor: "#d9d9d9 #ccc #b3b3b3",
        borderRadius: "2px",
        border: "1px solid #d9d9d9",
        minHeight: "25px",
        maxHeight: "auto",
        //height: state.isFocused ? "auto" : "25px",
        boxShadow: state.isFocused ? null : null,
        "&:hover": {
          borderColor: "#d9d9d9 #ccc #b3b3b3"
        },
        "&:focus": {
          borderColor: "#A6C8FF #A6C8FF #A6C8FF"
        },
        padding: 0,
        margin: 0,
        overflow: state.isFocused ? null : "hidden"
    }},
    menu: base => ({
        ...base,
        borderRadius: 2,
        hyphens: "auto",
        marginTop: 0,
        textAlign: "left",
        wordWrap: "break-word"
    }),
    menuList: base => ({
        ...base,
        padding: 0,
        verticalAlign: "baseline"
    }),
    singleValue: (base, state) => ({
        ...base,
        minHeight: "16px",
        lineHeight: "14px",
        color: "#333333",
        fontSize: "12px",
    }),
    option: (base, state) => ({
        ...base,
        padding: 0,
        fontSize: '0.80em',
        maxHeight: "25px"
    }),
    valueContainer: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        top: 0,

        fontSize: "12px",
    }),
    clearIndicator: (base, state) => ({
        ...base,
        padding: 0
    }),
    dropdownIndicator: (base, state) => ({
        ...base,
        marginTop: 0,
        padding: 0
    }),
    indicatorsContainer: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "23px",
        top: 0
    }),
    indicatorSeparator: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "0",
        top: 0
    }),
    input: (base, state) => ({
        ...base,
        padding: 0,
        margin: "2px 0 0 0",
        height: "20px",
        top: 0,
        fontSize: '12px',
        lineHeight: '0.8em',
        width: selectInFocusWithin ? '100%!important' : 'auto',
        div: {
            width: selectInFocusWithin ? '100%!important' : 'auto',
            input: {
                width: selectInFocusWithin ? '100%!important' : 'auto',
            },
        }
    }),
    noOptionsMessage: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        fontSize: '0.78em'
    })
}

/**
 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
 * @param {object} props
 */
const DropdownIndicator = (props) => {
    return (
        reactSelectComponents.DropdownIndicator && (
            <reactSelectComponents.DropdownIndicator {...props}>
                <span className={styles.downArrowHolder}>
                    <span className={styles.downArrow}></span>
                </span>
            </reactSelectComponents.DropdownIndicator>
    ))
}

/**
 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
 * @param {object} props
 */
const NoOptionsMessage = (props) => {
    return reactSelectComponents.DropdownIndicator && (
      <reactSelectComponents.NoOptionsMessage {...props} className={styles.noOptionsMessage}>
        {_('noOptions')}
      </reactSelectComponents.NoOptionsMessage>
    )
}

/**
 * This component make easy to use the react select 2 on a general way.
 */
export default class ReactSelect2 extends React.Component {

    /**
     * Constructor
     * @param {*} props
     */
    constructor(props) {
        super(props)
    }

    /**
     * Render the select
     */
    render() {
        return (<Select
            {...this.props}
            styles={{...customCreatableSelectStyles, ...this.props.customStyles}}
            components={{ DropdownIndicator, NoOptionsMessage }}
        />)
    }
}



// WEBPACK FOOTER //
// ./elements/ReactSelect2Wrapper.jsx